import {DATA_TYPE_NAMES} from "./widget-constants";

const Steve = require("@gluenetworks/steve_core").getInstance();

export const goToSteve = (params, openInNewTab) => {
    const redirectParams = {ra: null, ...params};
    Steve.router.goTo(redirectParams, openInNewTab);
};

export const goToSolutions = (obj, dataType, isMobileDevice, solution, openSolutionInNewTab) => {
    if (isMobileDevice) {
        return;
    }
    switch (dataType) {
        case DATA_TYPE_NAMES.AUDIT_POLICIES:
            goToSteve(
                {
                    app: "GameConsole",
                    s: "GameCenter",
                    sln: "ConfigDrift",
                    exp: "audit",
                    rd: obj,
                    ra: null,
                },
                openSolutionInNewTab
            );
            break;
        case DATA_TYPE_NAMES.DEVICES:
            goToSteve(
                {
                    app: "GameConsole",
                    s: "GameCenter",
                    sln: "DeviceManager",
                    exp: "device",
                    rd: obj,
                    ra: null,
                },
                openSolutionInNewTab
            );
            break;
        case DATA_TYPE_NAMES.FILE_SERVERS:
            goToSteve(
                {
                    app: "GameConsole",
                    s: "Settings",
                    sln: "Settings",
                    rd: obj,
                    sr: "Organization/OSManagement",
                    ra: null,
                },
                openSolutionInNewTab
            );
            break;
        case DATA_TYPE_NAMES.FILES:
            goToSteve(
                {app: "GameConsole", s: "GameCenter", sln: "FileServer", rd: obj, ra: null},
                openSolutionInNewTab
            );
            break;
        case DATA_TYPE_NAMES.OS_PLANS:
            goToSteve(
                {
                    app: "GameConsole",
                    s: "GameCenter",
                    sln: "OsManager",
                    exp: "plan",
                    rd: obj,
                    ra: null,
                },
                openSolutionInNewTab
            );
            break;
        case DATA_TYPE_NAMES.SCHEDULES:
            goToSteve(
                {app: "GameConsole", s: "GameCenter", sln: "WorkTriggers", rd: obj, ra: null},
                openSolutionInNewTab
            );
            break;
        default:
    }
};

export const shutdownFeed = async (feed) => {
    if (feed && typeof feed.shutdown === "function") {
        await feed.shutdown();
    }
};

// Reverse-maps a display title back to the underlying DB value.
// Handles two options formats:
//   Array: [{value, title}] — used by EDP/device fields
//   Object: {[dbValue]: {title}} — used by custom fields (ids.reduce path)
// Returns the original label when no match is found.
export const titleToValueForEnum = (displayLabel, options) => {
    if (!options) {
        console.warn("titleToValueForEnum: no options for", displayLabel);
        return displayLabel;
    }
    if (Array.isArray(options)) {
        const match = options.find((opt) => String(opt.title) === String(displayLabel));
        if (match?.value !== undefined) {
            return match.value;
        }
        console.warn("titleToValueForEnum: no match found for", displayLabel, options);
        return displayLabel;
    }
    const entry = Object.entries(options).find(
        ([, opt]) => String(opt.title) === String(displayLabel)
    );
    if (!entry) {
        console.warn("titleToValueForEnum: no match found for", displayLabel, options);
    }
    return entry ? entry[0] : displayLabel;
};

export const customColumnsReduceFunction = (customFields, [key, customField]) => {
    if (
        customField.enabled &&
        (!customField.systemOwned || customField.source === "ControllerDiscoveryConfig")
    ) {
        const customFieldColumn = {
            label: customField.label,
            description: customField.description || customField.label,
            entityColumn: false,
            shown: !!customField.systemOwned,
            path: `customFieldValues.${key}`,
            dataType: String(customField.dataType).toLowerCase(),
            typeInfo: customField.typeInfo || {},
            context: {...customField},
            groupable: customField.groupable,
        };
        const {labels, ids, multiSelect} = customFieldColumn.typeInfo;
        if (labels && ids && !multiSelect) {
            customFieldColumn.options = ids.reduce(
                (options, id, idx) => Object.assign(options, {[id]: {title: labels[idx]}}),
                {}
            );
        }
        return [...customFields, {[`customFieldValues.${key}`]: customFieldColumn}];
    }
    return customFields;
};
